// extracted by mini-css-extract-plugin
export default {"card":"Poliza_card__vTU-c","header":"Poliza_header__CfIyZ","price":"Poliza_price__HPW+G"};